export const DEFAULT_SIZE = "medium";
export const DEFAULT_VARIANT = "primary";
